// extracted by mini-css-extract-plugin
module.exports = {"wpcontainer":"WelcomePage_wpcontainer__HgJPy","wpbox_padding":"WelcomePage_wpbox_padding__1GqVg"};